import { render, staticRenderFns } from "./TestApplicationResultUpdateBatch.vue?vue&type=template&id=787b3e1e"
import script from "./TestApplicationResultUpdateBatch.vue?vue&type=script&lang=js"
export * from "./TestApplicationResultUpdateBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports